import { render, staticRenderFns } from "./DisableNotificationNeuerVertrag.vue?vue&type=template&id=26977826"
import script from "./DisableNotificationNeuerVertrag.vue?vue&type=script&lang=js"
export * from "./DisableNotificationNeuerVertrag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports